export const TrainingControlsCommand = {
  FC_LOSS: 'fc_loss',
  VEHICLE_DISCONNECTION: 'vehicle_disconnection',
  DAA: 'daa',
  REMOTE_ID_FAILURE: 'remote_id_failure',
  RESTART_VEHICLE: 'restart_vehicle',
  MOTOR_FAILURE: 'motor_failure',
  VERY_LOW_BATTERY: 'very_low_battery',
  ACCEL_VIBRATIONS: 'accel_vibrations',
  GEOFENCE_BREACH: 'geofence_breach',
  GPS_DEGRADATION: 'gps_degradation'
} as const;

export type TrainingControlsCommand = (typeof TrainingControlsCommand)[keyof typeof TrainingControlsCommand];
